import { Environment } from './api.constants';
import { format } from 'date-fns';
export const EMAIL_REGEX =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PHONE_REGEX = /^05[0-9]{1}\-?[0-9]{7}$/im;

export type obj = { [key: string]: string | number };

export const OrderBy = {
	ACSENDING: 'asc',
	DESENDING: 'desc',
};

export const maxFileSize = 10000000;

export const formatDate = (date: string) => {
	if (!date) {
		return '';
	}
	const dateStr = date.split('T');
	const [year, month, day] = dateStr[0].split('-');
	return `${day}.${month}.${year}`;
};

export const formatDateTime = (date: string) => {
	if (!date) {
		return '';
	}
	const parsedDate = new Date(date);

	return format(parsedDate, 'dd.MM.yyyy HH:mm');
};

export const formatJSDate = (date: Date) => {
	const year = String(date.getFullYear());
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${day}.${month}.${year}`;
};

export const formatDateForServer = (date: any) => {
	if (date) {
		const splitDate = date.split('.');
		return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
	}
	return date;
};

export enum tableHeaderTypeEnum {
	STRING = 'string',
	DATE = 'date',
	NUMBER = 'number',
	BOOLEAN = 'boolean',
}

export enum greetingEnum {
	MORNING = 'morning',
	NOON = 'noon',
	AFTERNOON = 'afternoon',
	EVENING = 'evening',
	HELLO = 'hello',
}

export const getTimeOfDay = () => {
	const localTime = new Date().toLocaleTimeString('he-IL', { timeZone: 'Asia/Jerusalem' });
	if ('06:00:00' <= localTime && localTime <= '11:59:59') {
		return greetingEnum.MORNING;
	} else if ('12:00:00' <= localTime && localTime <= '15:59:59') {
		return greetingEnum.NOON;
	} else if ('16:00:00' <= localTime && localTime <= '17:59:59') {
		return greetingEnum.AFTERNOON;
	} else if ('18:00:00' <= localTime && localTime <= '05:59:59') {
		return greetingEnum.EVENING;
	} else {
		return greetingEnum.HELLO;
	}
};

export const formatNumber = (number?: number) => {
	const shortNumber = number?.toFixed(2);
	const splitNumber = String(shortNumber).split('.');
	return splitNumber;
};

export enum generalStatusEnum {
	PENDING = 'Pending',
	AWAITING = 'Awaiting',
	DECLINED = 'Declined',
	CANCELED = 'Canceled',
	APPROVED = 'Approved',
	APPROVEDWITHRISK = 'ApprovedWithRisk',
	COMPLETED = 'Completed',
	PROBATION = 'Probation',
	COMPLIANCE = 'Compliance',
	SUSPENDED = 'Suspended',
	REJECTED = 'Rejected',
	DELETED = 'Deleted',
	DENIED = 'Denied',
	PENDINGCCTRANSFER = 'PendingCCTransfer',
	PENDINGSIGNING = 'PendingSigning',
	SIGNEDPENDINGBOAPPROVAL = 'SignedPendingBOApproval',
	PENDINGBANKACCOUNTDETAILS = 'PendingBankAccountDetails',
	PENDINGBOSIGNERREVIEW = 'PendingBoSignerReview',
	PENDINGSCHEDULER = 'PendingScheduler',
	AWAITINGFUNDS = 'AwaitingFunds',
	AWAITINGAUTHORIZATION = 'AwaitingAuthorization',
	AWAITINGALTSHULERAUTHORIZATION = 'AwaitingAltshulerAuthorization',
	PENDINGBOAPPROVAL = 'SignedPendingBOApproval',
	Cancel = 'Cancel',
	DECLINED_FOR_REPAIR = 'DeclinedForRepair',
	ICONDUCT_ACCEPTED = 'accepted',
	ICONDUCT_DECLINED = 'declined',
}

export enum RiskType {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
	VERY_HIGH = 'veryHigh',
}

export enum UserPermissionType {
	None = 'None',
	Viewer = 'Viewer',
	Operationer = 'Operationer',
	Signer = 'Signer',
}

export enum ContactStatus {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected',
	Deleted = 'Deleted',
	Denied = 'Denied',
}

export enum ContactLegalStatus {
	Legal = 'Legal',
	NotLegal = 'NotLegal',
}

export enum Gender {
	Male = 'Male',
	Female = 'Female',
}

export const riskTypeOptions = [
	{ value: RiskType.LOW, label: RiskType.LOW },
	{ value: RiskType.MEDIUM, label: RiskType.MEDIUM },
	{ value: RiskType.HIGH, label: RiskType.HIGH },
	{ value: RiskType.VERY_HIGH, label: RiskType.VERY_HIGH },
];

export const contactPermissionHebrew: any = {
	Signer: 'חתימה',
	Operationer: 'פעולה',
	Viewer: 'צפיה',
};

export const permissionOptions = [
	{ value: UserPermissionType.Viewer, label: contactPermissionHebrew.Viewer },
	{ value: UserPermissionType.Operationer, label: contactPermissionHebrew.Operationer },
	{ value: UserPermissionType.Signer, label: contactPermissionHebrew.Signer },
];

export const contactLegalStatusOptions = [
	{ value: ContactLegalStatus.Legal, label: ContactLegalStatus.Legal },
	{ value: ContactLegalStatus.NotLegal, label: 'Not legal' },
];

export const globalEnvironment = (function () {
	const host = document.location.host;

	if (host.includes('localhost')) {
		return Environment.Local;
	} else if (host.includes('azurestaticapps.net')) {
		return Environment.Development;
	} else if (host.includes('demo.open')) {
		return Environment.Staging;
	} else if (host.includes('open-global') || host.includes('open.global')) {
		return Environment.Production;
	} else return Environment.Local;
})();

//'.pdf,.jpeg,.jpg,.png,.doc,.docx,.ppt,.pptx';
export const acceptableFileFormats = '.pdf,.jpeg,.jpg,.png,.doc,.docx,.ppt,.pptx';

export const fileTooBigError = 'validations.errors.fileSizeTooLarg';
export const fileExtensionError = 'validations.errors.fileNotSupported';

export enum accountStatus {
	ACTIVE = 'פעיל',
	NOT_ACTIVE = 'לא פעיל',
}

export enum contactStatusHebrew {
	APPROVED = 'מאושר',
	NOT_APPROVED = 'לא מאושר',
}

export const contactStatusOptions = [
	{ value: ContactStatus.Approved, label: contactStatusHebrew.APPROVED },
	{ value: ContactStatus.Rejected, label: contactStatusHebrew.NOT_APPROVED },
];

export const contactRequestStatusOptions = [
	{ value: ContactStatus.Pending, label: ContactStatus.Pending },
	{ value: ContactStatus.Denied, label: ContactStatus.Denied },
];

export const generalTranslation: any = {
	Payment: 'תשלום',
	Balance: 'יתרה',
	Conversion: 'המרה',
	PaynentFee: 'עמלת תשלום',
	ConversionFee: 'עמלת המרה',
	BalanceRefund: 'זיכוי',
	Approved: 'מאושר',
	ApprovedWithRisk: 'מאושר עם התניה',
	Withdrawal: 'משיכת יתרה',
	'Topping Up the Account': 'הוספת יתרה',
	'Topping Up the Account Digital': 'הוספת יתרה דיגיטלית',
	'Create Company': 'הקמת חברה',
	'Update Credit Card': 'עדכון כרטיס אשראי',
	Rejected: 'נדחה',
	AwaitingAltshulerAuthorization: 'ממתין',
	Completed: 'הסתיים',
	Pending: 'ממתין',
	PendingScheduler: 'ממתין',
	PendingCCTransfer: 'ממתין לסיום העברת כספים',
	Priority: 'מועדף',
	Regular: 'מקומי',
	Shared: 'משותף',
	Our: 'שלנו',
	Goods: 'טובין',
	Services: 'שירותים מקצועיים',
	Investments: 'השקעה',
	Awaiting: 'ממתין',
	Declined: 'סורב',
	DeclinedForRepair: 'נדחה',
	Failed: 'נכשל',
	Canceled: 'בוטל',
	Probation: 'תנאי',
	Compliance: 'ציות',
	Suspended: 'מושהה',
	Deleted: 'נמחק',
	Denied: 'נדחה',
	Cancel: 'בוטל',
	Legal: 'חוקי',
	NotLegal: 'לא חוקי',
	ID: 'ת.ז',
	Passport: 'דרכון',
	Male: 'גבר',
	Female: 'אישה',
	None: 'נתון חסר',
	Company: 'חברה',
	Individual: 'עוסק',
	PendingSigning: 'ממתין לחתימה',
	SignedPendingBOApproval: 'חתום וממתין לאישור',
	PendingBankAccountDetails: 'ממתין לפרטי בנק',
	PendingBoSignerReview: 'ממתין',
	AwaitingFunds: 'ממתין',
	AwaitingAuthorization: 'ממתין לאישור לקוח מורשה חתימה',
	accepted: 'התקבל',
	declined: 'נדחה',
	expired: 'פג תוקף',
};

export const generalBankAccountTranslation: any = {
	Rejected: 'לא מאושר',
	Completed: 'מאושר',
	Pending: 'חתום וממתין לאישור',
};

export const genderOptions = [
	{ value: Gender.Male, label: generalTranslation.Male },
	{ value: Gender.Female, label: generalTranslation.Female },
];

export const nonEditableStatus = [
	generalStatusEnum.REJECTED,
	generalStatusEnum.DECLINED,
	generalStatusEnum.DELETED,
	generalStatusEnum.CANCELED,
	generalStatusEnum.PENDINGSIGNING,
	generalStatusEnum.PENDING,
	generalStatusEnum.AWAITING,
	generalStatusEnum.AWAITINGALTSHULERAUTHORIZATION,
	generalStatusEnum.AWAITINGAUTHORIZATION,
	generalStatusEnum.AWAITINGFUNDS,
	generalStatusEnum.PENDINGBANKACCOUNTDETAILS,
	generalStatusEnum.PENDINGBOSIGNERREVIEW,
	generalStatusEnum.PENDINGCCTRANSFER,
	generalStatusEnum.PENDINGSCHEDULER,
	generalStatusEnum.PENDINGSIGNING,
	generalStatusEnum.PENDINGBOAPPROVAL,
	generalStatusEnum.DECLINED_FOR_REPAIR,
];

export const nonEditableHebrewStatus = [
	generalTranslation.Rejected,
	generalTranslation.DeclinedForRepair,
	generalTranslation.Declined,
	generalTranslation.Canceled,
	generalTranslation.Deleted,
	generalTranslation.PendingSigning,
	generalTranslation.Pending,
	generalTranslation.Awaiting,
	generalTranslation.AwaitingAltshulerAuthorization,
	generalTranslation.AwaitingAuthorization,
	generalTranslation.AwaitingFunds,
	generalTranslation.PendingBankAccountDetails,
	generalTranslation.PendingBoSignerReview,
	generalTranslation.PendingCCTransfer,
	generalTranslation.PendingScheduler,
	generalTranslation.PendingSigning,
	generalTranslation.SignedPendingBOApproval,
];

export const WorldCheckStatus: any = {
	Approved: 'מאושר',
	Compliance: 'ממתין לאישור ציות',
};
